<!--
用户信息展示，含头像、昵称、手机号

用法：
<lc-user :user="user"></lc-user>
-->
<template>
  <div class="lc-user clearfix" :style="{ width: width + 'px' }">
    <!-- 不能使用 el-avatar 是因为 有缓存问题，翻页过程头像会丢失 -->
    <a :href="userDetailUri" class="avatar">
      <el-image v-if="user.avatar" class="avatar-image" :src="user.avatar" style="width: 30px; height: 30px;">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </a>

    <div class="m-l-5" style="width: calc(100% - 30px)">
      <div class="nickname">
        <a :href="userDetailUri">
          <span class="name-left m-r-5" :class="{ 'vip-nickname': user.is_vip }">{{ user.nick_name }}</span>
        </a>
        <el-image v-if="user.is_vip" src="/images/vip-round.png" style=" width: 16px;"></el-image>
      </div>
      <div class="mobile">{{ mobile(user.mobile) }}</div>
    </div>
  </div>
</template>

<script>
import Auth from '@/helpers/authorizations'

export default {
  props: {
    /**
     * 用户信息
     * 结构: {id, avatar, nick_name, mobile}
     */
    user: {
      type: Object,
      default: () => {}
    },
    /**
     * 是否可以跳转到详情页
     */
    routeable: {
      type: Boolean,
      default: true
    },
    /**
     * 宽度
     */
    width: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    userDetailUri() {
      if (!this.isEmptyObject(this.userDetailRouter(this.user))) {
        return this.userDetailRouter(this.user)
      }

      return 'javascript:void(0)'
    }
  },
  methods: {
    /**
     * 用户的路由信息
     *
     * @param {object} user 用户
     * @returns {string} 详情页路由。如果没有权限，则不显示路由
     */
    userDetailRouter(user) {
      if (!this.can(Auth.showUser) || !this.routeable) {
        return ''
      }
      return `/users/${user.id}/detail`
    },
    /**
     * 用户详情页的事件
     *
     * @returns {string} 当事件为 '' 时，router link 点击不会跳转
     */
    userDetailEvent() {
      return this.can(Auth.showUser) ? 'click' : ''
    },
    /**
     * 拷贝内容
     *
     * @param {string} cellId 要拷贝的Cell的ID
     */
    copy(cellId) {
      /* Get the text field */
      let copyTextElem = document.getElementById(cellId)

      let range, selection

      if (document.body.createTextRange) {
        range = document.body.createTextRange()
        range.moveToElementText(copyTextElem)
        range.select()
      } else if (window.getSelection) {
        selection = window.getSelection()
        range = document.createRange()
        range.selectNodeContents(copyTextElem)
        selection.removeAllRanges()
        selection.addRange(range)
      }

      try {
        document.execCommand('copy')
        this.$toast.success(`${this.$t('charger.tips.copy_success')} ${copyTextElem.textContent}`)
      } catch (err) {
        this.$toast.error(this.$t('charger.tips.copy_fail'))
      }
    },
    /**
     * 电话裁剪
     * 主要是避免展示过长的换行问题
     *
     * @param {string} mobile 电话
     * @returns {string} 裁剪后的电话
     */
    mobile(mobile) {
      if (this.isEmptyObject(mobile)) return '-'

      if (mobile.length === 14) {
        // 14 位的是互联互通
        return mobile.substring(2, 11)
      }

      return mobile
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-user {
  display: inline-flex;
  width: 100%;
  overflow: hidden;
  // min-width: 130px; // 会导致 table 在 safari 下行错位
}
.nickname {
  white-space: nowrap;
  color: #333;
  line-height: 19px;
  height: 19px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  .name-left {
    display: inline-block;
    max-width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.vip-nickname {
  color: #ea363d;
}
.mobile {
  font-size: 12px;
  color: #999;
  line-height: 12px;
}
.avatar {
  height: 30px;
  // 避免组件在列表固定列宽的列中被过长的名字导致塌陷
  min-width: 30px;
  border-radius: 3px;
  overflow: hidden;

  ::v-deep .image-slot {
    background-color: #eee;
    text-align: center;
    line-height: 30px;
  }
}
</style>
